import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useCreateEnquiry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      const res = await api.post("/enquiry/create", body);
      return res.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["enquiryList"] });
    },
  });
};
